// flatpickr

'use strict';

icing.watch('[data-flatpickr]', input => {
    import(/* webpackChunkName: 'flatpickr' */ 'flatpickr')
        .then(({default: flatpickr}) => {
            window.Flatpickr = flatpickr;

            const userOptions = input.dataset.flatpickr ? JSON.parse(input.dataset.flatpickr) : {};

            const options = {
                dateFormat: 'Y-m-d',
                //defaultHour: new Date().getHours(),
                //defaultMinute: new Date().getMinutes(),
                placement: 'auto',
                _position: function (self, positionElement) {

                    if (!positionElement) return;
                    //fixing the calendar getting cut off at the bottom of the screen
                    var calendarHeight = self.calendarContainer.offsetHeight ,
                        calendarWidth = self.calendarContainer.offsetWidth,
                        viewportPadding = 30,
                        configPos = self.config.placement.split(" "),
                        configPosVertical = configPos[0],
                        configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
                        inputBounds = positionElement.getBoundingClientRect(),
                        distanceFromBottom = window.innerHeight - inputBounds.bottom,
                        showOnTop = configPosVertical === "above"
                            || (
                                configPosVertical !== "below"
                                && distanceFromBottom < calendarHeight + viewportPadding
                                && inputBounds.top > calendarHeight
                            ),
                        top = window.pageYOffset
                            + inputBounds.top
                            + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);

                    self.calendarContainer.classList.toggle("arrowTop", !showOnTop);
                    self.calendarContainer.classList.toggle("arrowBottom", showOnTop);

                    if (self.config.inline)
                        return;
                    var left = window.pageXOffset + inputBounds.left;
                    var isCenter = false;
                    var isRight = false;
                    if (configPosHorizontal === "center") {
                        left -= (calendarWidth - inputBounds.width) / 2;
                        isCenter = true;
                    } else if (configPosHorizontal === "right") {
                        left -= calendarWidth - inputBounds.width;
                        isRight = true;
                    }
                    self.calendarContainer.classList.toggle("arrowLeft", !isCenter && !isRight);
                    self.calendarContainer.classList.toggle("arrowCenter", isCenter);
                    self.calendarContainer.classList.toggle("arrowRight", isRight);
                    var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
                    var rightMost = left + calendarWidth > window.document.body.offsetWidth;
                    var centerMost = right + calendarWidth > window.document.body.offsetWidth;
                    self.calendarContainer.classList.toggle("rightMost", rightMost);
                    if (self.config.static) return;
                    self.calendarContainer.style.top = top + "px";
                    if (!rightMost) {
                        self.calendarContainer.style.left = left + "px";
                        self.calendarContainer.style.right = "auto";
                    } else if (!centerMost) {
                        self.calendarContainer.style.left = "auto";
                        self.calendarContainer.style.right = right + "px";
                    } else {
                        var doc = getDocumentStyleSheet();
                        // some testing environments don't have css support
                        if (doc === undefined)
                            return;
                        var bodyWidth = window.document.body.offsetWidth;
                        var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
                        var centerBefore = ".flatpickr-calendar.centerMost:before";
                        var centerAfter = ".flatpickr-calendar.centerMost:after";
                        var centerIndex = doc.cssRules.length;
                        var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
                        self.calendarContainer.classList.toggle("rightMost", false);
                        self.calendarContainer.classList.toggle("centerMost", true);
                        doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
                        self.calendarContainer.style.left = centerLeft + "px";
                        self.calendarContainer.style.right = "auto";
                    }
                },
                ...userOptions,
            };

            const button = input.type === 'button';

            window.Flatpickr(input, options);

            if (button) {
                input.type = 'button';
            }
        })
        .catch(console.warn);

});
